module.exports = __webpack_public_path__ + "img/fitshow-title-back-image-3.1d59c8ad.jpg";